import { z } from 'zod';
export const LAUNCH_CONSENT = 'Jeg ønsker e-mails om lanceringen af MinNyeElbil.dk. Jeg kan altid trække mit samtykke tilbage.';
export const LAUNCH_VERSION = 'launch-v1';
export const launchSignupSchema = z.object({ email: z.string().trim().toLowerCase().email('Indtast en gyldig e-mailadresse.').max(255), consent: z.literal(true), website: z.string().max(0), version: z.literal(LAUNCH_VERSION) });
export function isLaunchEnabled(value: string | undefined) { return value === 'true'; }
